import useTranslation from 'next-translate/useTranslation';
import { usePathname } from 'next/navigation';

// Lib
import { CONTENT_ALBUMS, CONTENT_ALBUMS_COMPARATIVE_TABLE } from '@/routes/privateRoutes';

// Components
import { PageHeaderRecap } from '@/components/layouts/LayoutPlatform/components/PageHeaderRecap';
import AlbumsCreateButton from '@/components/pages/albums/AlbumsCreateButton';

// Types
import type { DropdownLinksType } from '@/components/layouts/LayoutPlatform/components/PageHeaderRecap';
import type { AlbumsCreateButtonProps } from '@/components/pages/albums/AlbumsCreateButton';

type AlbumsPageHeaderRecapProps = {
    toggleAlbumFunnel: AlbumsCreateButtonProps['onClick'];
};

const AlbumsPageHeaderRecap = ({ toggleAlbumFunnel }: AlbumsPageHeaderRecapProps) => {
    const { t } = useTranslation();
    const pathname = usePathname();

    const dropdownLinks: DropdownLinksType = [
        { href: CONTENT_ALBUMS, label: t('content:albums') },
        { href: CONTENT_ALBUMS_COMPARATIVE_TABLE, label: t('content:albums_comparative_table') }
    ];

    return (
        <PageHeaderRecap
            title={dropdownLinks.find((link) => link.href === pathname)?.label}
            dropdownLinks={dropdownLinks}>
            {({ isSticky }) => (
                <AlbumsCreateButton size={isSticky ? 'sm' : 'md'} onClick={toggleAlbumFunnel} />
            )}
        </PageHeaderRecap>
    );
};

export default AlbumsPageHeaderRecap;
